import styled from 'styled-components';

import { rem } from '@vimeo/bokeh';
import { slate, white } from '@vimeo/iris/color';
import { Tip } from '@vimeo/iris/components';

export const PlanCardContainer = styled.div`
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: ${rem(20)};
  border: ${rem(2)} solid
    ${({ theme }) => theme?.modal?.planCard?.border || 'var(--vimeo-colors-stroke)'};
  background: var(--vimeo-colors-fill-surface);
  max-width: 19.5rem;
  position: relative;

  &.recommended {
    border: 4px solid #8a5ee8;
    border-top: none;
  }
`;

export const PlanHeader = styled.div`
  max-height: 4rem;
`;

export const PlanTitle = styled.div`
  color: var(--vimeo-colors-text-primary);
  font-size: ${rem(22)};
  line-height: 120%;
  letter-spacing: ${rem(-0.8)};
  font-weight: 700;
`;

export const PlanSubTitle = styled.p`
  margin-top: 0.125rem;
  color: var(--vimeo-colors-text-primary);
  font-size: ${rem(14)};
  font-weight: 400;
  letter-spacing: 0.03rem;
  line-height: 120%;
`;

export const PlanPriceContainer = styled.div`
  padding: 0.25rem 0rem 0rem 0rem;
  height: ${rem(94)};
`;

export const PlanPrice = styled.div`
  color: var(--vimeo-colors-text-primary);
  font-size: ${rem(36)};
  font-weight: 700;
  line-height: 120%;
  letter-spacing: ${rem(-1.2)};
`;

export const PlanBillingInfo = styled.p`
  color: ${({ theme }) => theme?.modal?.secondaryText || 'var(--vimeo-colors-text-secondary)'};
  font-size: ${rem(12)};
  font-weight: 400;
  line-height: 120%;
`;

export const PlansFeaturesContainer = styled.div`
  padding-top: 4px;
`;

export const FeaturesText = styled.div`
  color: var(--vimeo-colors-text-primary);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 128.5%;
  letter-spacing: -0.00875rem;
`;

export const FeaturesWrapper = styled.ul`
  list-style-type: disc;
  list-style-position: outside;
  padding: 0;
`;

export const FeatureList = styled.li`
  color: var(--vimeo-colors-text-primary);
  display: flex;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  list-style-type: none;
  padding: 0.25rem 0;
  letter-spacing: ${rem(0.1)};
  column-gap: ${rem(4)};
`;

export const EnterprisePricingInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  align-self: stretch;
  height: 3rem;
  padding-top: 0.25rem;
  color: ${slate(900)};
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const RecommendedBadge = styled.div`
  position: absolute;
  top: -1.5rem;
  left: ${rem(-4)};
  padding: 0.125rem 0.25rem 0.5rem;
  border-radius: ${rem(20)};
  background: #8a5ee8;
  color: #fff;
  font-size: ${rem(12)};
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: ${rem(0.24)};
  z-index: -1;
  height: ${rem(75)};
  width: 100%;
  text-align: center;
  box-sizing: content-box;
`;

export const TalkToOurTeam = styled.div`
  color: var(--vimeo-colors-text-primary);
  font-size: ${rem(16)};
  line-height: ${rem(18)};
  font-weight: 500;
  margin-bottom: ${rem(19)};
  margin-left: ${rem(6)};
`;

export const PlanQuotaContainer = styled.div`
  font-size: ${rem(14)};
  font-style: normal;
  font-weight: 500;
  line-height: ${rem(20)};
  color: var(--vimeo-colors-text-primary);
`;

export const StorageQuotaContainer = styled.div`
  display: flex;
  row-gap: ${rem(4)};
  flex-direction: column;
`;

export const StyledRow = styled.div`
  display: flex;
  column-gap: ${rem(4)};
  > div {
    display: flex;
    align-items: flex-start;
  }
`;

export const ToolTipWrapper = styled.div`
  height: ${rem(16)} !important;
  margin: auto 0;
  padding: 0 !important;
`;

export const StyledTip = styled(Tip)`
  font-size: ${rem(14)};
  fontweight: 400;
  line-height: ${rem(16)};
  letter-spacing: ${rem(0.1)};
`;
